// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1759":"6ee59436","3666":"13f52343","3673":"13f52343","4244":"d2066eb1","5372":"c4fd0cc6","7881":"13f52343","7915":"6ee59436"}[chunkId] + ".chunk.css";
};